<script setup>
import draggable from "vuedraggable";
import {ref, watch} from "vue";
import customFieldsService from "@/services/custom-fields.service";
import userColumnsService from "@/services/user-columns.service";

const props = defineProps(['tableType', 'useType', 'trackerId']);

const typesLabels = {
    info: 'About',
    question: 'Question',
    diligence: 'Tracker Diligence',
    review: 'Review',
    profile: 'Profile Field',
    custom: 'Profile Field',
};

const emit = defineEmits(['changed']);
const columns = ref([]);
const profileColumns = ref([]);

watch(columns, (value) => {
    emit('changed', value.filter(column => column.checked));
}, {deep: true});

watch(() => props.useType, () => {
    getColumns();
}, {immediate: true});

async function getColumns() {
    const {data: columnsData} = await userColumnsService.getColumnsForManage(props.tableType, props.useType, props.trackerId);
    columns.value = columnsData;

    if (props.tableType === 'tracker-startups') {
        const {data: profileData} = await customFieldsService.getFields('company_diligence', 1);

        profileColumns.value = Object.values(profileData).flat().map(column => ({
            id: column.id,
            name: 'custom_' + column.id,
            type: 'profile',
            label: column.name,
            checked: columns.value.some(item => item.type === 'profile' && item.id === column.id && item.checked),
        }));
    }
}

function fieldChecked(column) {
    columns.value.push(column);
}

function fieldUnChecked(column) {
    if (props.tableType === 'tracker-startups' && column.type === 'profile') {
        columns.value = columns.value.filter(item => item.type !== column.type || item.id !== column.id);
        profileColumns.value.find(item => item.id === column.id).checked = false;
    }
}

</script>

<template>
    <div>
        <draggable v-model="columns">
            <div
                v-for="(column, index) in columns"
                :key="column.id"
                v-show="column.id !== 1"
                class="list-drag-n-drop__item"
            >
                <div>
                    <span class="input-checkbox">
                        <input :id="column.type + column.id" v-model="columns[index].checked" type="checkbox" @change="fieldUnChecked(column)">
                        <label :for="column.type + column.id">{{ column.label }}</label>
                    </span>
                    <span class="hint-secondary" v-if="column.info" v-b-popover.hover.top="{ customClass: 'hint-secondary-popover', content: column.info }"></span>
                </div>
                <div>
                    {{typesLabels[column.type]}}
                </div>
            </div>
        </draggable>

        <template v-if="tableType === 'tracker-startups'">
            <h5 class="heading5 heading5--secondary">Profile Fields</h5>
            <p>Profile fields display on the startup profile and can be edited there or from your tracker.</p>

            <header class="accordion__header" v-b-toggle:profile-fields>
                <a class="accordion__title link">Add More Fields</a>
            </header>

            <b-collapse accordion="profile-fields" id="profile-fields">
                <template v-for="(column, index) in profileColumns">
                    <div v-if="!column.checked" :key="column.id" class="list-drag-n-drop__item">
                        <div>
                            <span class="input-checkbox">
                                <input :id="column.type + column.id" v-model="profileColumns[index].checked" type="checkbox" @change="fieldChecked(column)">
                                <label :for="column.type + column.id">{{ column.label }}</label>
                            </span>
                        </div>
                        <div>
                            {{typesLabels[column.type]}}
                        </div>
                    </div>
                </template>
            </b-collapse>
        </template>
    </div>
</template>

<style scoped>
     .list-drag-n-drop__item {
         flex: 1 !important;
         width: 100%;
         display: flex;
         justify-content: space-between;
     }
</style>
